import { Currency } from '../enums/currency-enum';

/**
 * Mapping of Currency enum values to their corresponding symbol values.
 */
const currencySymbols: Record<Currency, string> = {
  [Currency.USD]: '$', // US Dollar
  [Currency.CAD]: '$', // Canadian Dollar
  [Currency.AUD]: '$', // Australian Dollar
  [Currency.EUR]: '€', // Euro
  [Currency.GBP]: '£', // British Pound
  [Currency.JPY]: '¥', // Japanese Yen
  [Currency.KRW]: '₩', // South Korean Won
  [Currency.HKD]: '$', // Hong Kong Dollar
  [Currency.SGD]: '$', // Singapore Dollar
  [Currency.CNY]: '¥', // Chinese Yuan (onshore)
  [Currency.CNH]: '¥', // Chinese Yuan (offshore)
  [Currency.CHF]: 'Fr ', // Swiss Franc
  [Currency.SEK]: 'kr ', // Swedish Krona
  [Currency.NOK]: 'kr ', // Norwegian Krone
};

/**
 * Retrieves the currency symbol for a given ISO code.
 * Returns an empty string if the currency does not have a symbol.
 * @param currency The ISO code of the currency.
 * @returns The currency symbol, or blank if unavailable.
 */
export function getCurrencySymbol(currency: Currency): string {
  return currencySymbols[currency] || '';
}
